import { t as isomorphicAtob } from "./isomorphicAtob-CoF80qYz.mjs";

export { isomorphicAtob };